import React from 'react'
import { Form } from "react-bootstrap"
import Col from "react-bootstrap/Col"


const SelectField = ({name, required, placeholder, values, handlechange, fieldClass, label, grpmd, componentprops, step, type}) => (
  <Form.Group as={Col} md={grpmd} className={`${type} ${step}`} controlId={"validation" + name}>
    { label
      ? <p className="label"><Form.Label className="form-label">{label}{required ? '*' : ''}</Form.Label></p>
      : ''

    }
    <Form.Control
		className={fieldClass}
		required={required}
		name={name}
		onChange={handlechange}
		as="select"
    value={componentprops ? componentprops[name] : ''}
		>
    <option value="" key="">{placeholder}</option>
		{values.map(val =><option value={val} key="">{val}</option>)}
    </Form.Control>
  </Form.Group>

);

export default SelectField;